<div class="full-width">
    <button class="card-inline" *ngIf="!loadingAction" mat-mini-fab type="button" (click)="export()">
    <mat-icon>cloud_download</mat-icon>
</button>
    <button class="card-inline" *ngIf="!loadingAction" type="button" (click)="fileInput.click()" mat-mini-fab>
    <mat-icon>cloud_upload</mat-icon>
    <input [style.display]="hideElement?'none':'inherit'" type="file" #fileInput (change)="import($event.target.files)">
 </button>
    <mat-spinner [diameter]="20" *ngIf="loadingAction"></mat-spinner>
</div>
<p-scrollPanel styleClass="scroll-panel">
    <table class="search-table search-table-fixed" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="protocol">
            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Protocolo" #resColDateTime></resizable-column-control>
            </th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{element.Protocol }}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="patientFullName">
            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="150" tile="Paciente" #resColDateTime></resizable-column-control>
            </th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.PatientFullName }}</div>
            </td>
        </ng-container>
        <ng-container matColumnDef="practiceName">
            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Práctica" #resColDateTime></resizable-column-control>
            </th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.PracticeName }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="amount">
            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Importe" #resColDateTime></resizable-column-control>
            </th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.Amount }}</div>
            </td>
        </ng-container>

        <ng-container matColumnDef="taxAmount">
            <th class="search-table-header resizable-column" mat-header-cell *matHeaderCellDef>
                <resizable-column-control width="100" tile="Iva" #resColDateTime></resizable-column-control>
            </th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <div>{{ element.TaxAmount }}</div>
            </td>
        </ng-container>

        <!-- Star Column -->
        <ng-container matColumnDef="Star" stickyEnd>
            <th class="search-table-header" mat-header-cell *matHeaderCellDef></th>
            <td class="search-table-cell" mat-cell *matCellDef="let element">
                <mat-spinner *ngIf="element.Loading" [diameter]="15"></mat-spinner>
                <button type="button" mat-icon-button *ngIf="!element.Loading" [matMenuTriggerFor]="menuItem">
                  <mat-icon>more_vert</mat-icon>
              </button>
                <mat-menu #menuItem="matMenu">
                    <button type="button" (click)="deleteItem(element)" mat-menu-item>
                    <mat-icon>delete</mat-icon><span>Excluir</span>
                  </button>
                </mat-menu>
            </td>
        </ng-container>
        <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row class="search-table-cell" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</p-scrollPanel>
<pager (selectedPageIndexChange)="selectedPageIndexChange($event)" #pager></pager>